module.exports = __webpack_public_path__ + "static/media/kit-more.5921e8e5.png";